import { name as root } from '../actionTypes';

export const name = `${root}/softwareproducts`

export const FETCH_SOFTWARE_PRODUCTS_REQUEST = `${name}/request`
export const FETCH_SOFTWARE_PRODUCTS_SUCCESS = `${name}/success`
export const FETCH_SOFTWARE_PRODUCTS_FAILURE = `${name}/failure`
